import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';

const MapSection: React.FC = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography 
            variant="h3" 
            component="h2" 
            align="center" 
            gutterBottom
            sx={{ mb: 1 }}
          >
            Poloha
          </Typography>
          <Typography 
            variant="h6" 
            color="text.secondary" 
            align="center" 
            sx={{ mb: 4 }}
          >
            Náš apartmán se nachází na Costa del Sol
          </Typography>
          
          <Paper 
            elevation={3} 
            sx={{ 
              overflow: 'hidden',
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            }}
          >
            <Box
              sx={{
                position: 'relative',
                paddingTop: '56.25%', // 16:9 aspect ratio
                width: '100%',
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d4087.7144464763437!2d-5.2242010436534265!3d36.372752187039815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2scz!4v1745085849453!5m2!1sen!2scz"
                width="100%"
                height="100%"
                style={{ 
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  border: 0,
                }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Costa del Sol Location"
              />
            </Box>
          </Paper>
          
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="body1" color="text.secondary">
              Apartmán se nachází v klidné lokalitě s přímým přístupem k pláži a nádherným výhledem na moře.
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default MapSection; 